import { Typography } from "@mui/material";

const ErrorComponent = ({ message }) => {
  return (
    <div>
      <Typography variant="h4" sx={{ marginBottom: "25px" }}>
        Opps! {message}
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: "25px" }}>
        For more details about this project, feel free to contact me.
      </Typography>
      <hr />
      <Typography variant="body2" sx={{ marginBottom: "25px" }}>
        Email : harshitratanshukla@gmail.com
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "25px" }}>
        Phone Number : +91 94150-93948
      </Typography>
      <hr />
    </div>
  );
};

export default ErrorComponent;
